import { i18n } from '@/i18n'
import store from '@/store'

export default (params) => {
  const role = store.getters['auth/role']
  const hasModuleVacacionesAEAT = store.getters['auth/hasModuleVacacionesAEAT']
  const hasModulePresentacionesAEAT = store.getters['auth/hasModulePresentacionesAEAT']
  const hasModuleContestacionDiligencias = store.getters['auth/hasModuleContestacionDiligencias']
  const hasModuleHotFolder = store.getters['auth/hasModuleHotFolder']
  const menu = [
    {
      icon: 'companies',
      name: i18n.t('app.companies'),
      path: 'companies',
      use_parent_params: true,
      params_required: ['id'],
      registerNavFromMenu: false,
      sc: [
        {
          name: i18n.t('app.detail'),
          path: 'companies/detail',
          params,
          registerNavFromMenu: false,
          sc: [] // shorcuts
        },
        {
          name: i18n.t('app.locations_link'),
          path: 'companies/locations',
          params,
          registerNavFromMenu: false,
          disabled: params.id === -1 || params.id === '-1',
          sc: [] // shorcuts
        },
      ]
    }
  ]
  const submenuCertificates = {
    name: i18n.t('app.other_certificates'),
    path: 'companies/certificates',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const submenuCourtesyDaysAEAT = {
    name: i18n.t('companies.courtesy_days_aeat'),
    path: 'companies/courtesydaysaeat',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const subMenuHotFolder = {
    name: i18n.t('hotfolder.title'),
    path: 'companies/hotfolder',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  const submenuHistorical = {
    name: i18n.t('app.historical'),
    path: 'companies/historical',
    params,
    registerNavFromMenu: false,
    disabled: params.id === -1 || params.id === '-1',
    sc: [] // shorcuts
  }
  if (hasModulePresentacionesAEAT || hasModuleContestacionDiligencias) {
    menu[0].sc.push(submenuCertificates)
  }
  if (hasModuleVacacionesAEAT && (role === 'Administrador' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')) {
    menu[0].sc.push(submenuCourtesyDaysAEAT)
  }
  if (hasModuleHotFolder && (role === 'Administrador' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador')) {
    menu[0].sc.push(subMenuHotFolder)
  }
  menu[0].sc.push(submenuHistorical)

  return menu
}
